import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import AssistanceFormik from './AssistanceFormik'
import { IAssistanceCategoryObject, IAssistanceObject } from '../../types'

interface IAddAssistanceModalProps {
  categories: IAssistanceCategoryObject[]
  create: (assistance: IAssistanceObject) => Promise<any>
  getAssistances: () => void
}

export default class AddAssistanceModal extends React.Component<RouteComponentProps<any> & IAddAssistanceModalProps> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <AssistanceFormik
              title='ADD ASSISTANCE'
              onSuccess={this.onSuccess}
              onSubmit={this.onSubmit}
              categories={this.props.categories}
            >
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </AssistanceFormik>
          </div>
        </div>
      </Modal>
    )
  }

  private onSubmit = (values: any): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
      this.props
        .create({
          id: '',
          type: values.type,
          categoryId: values.category,
          instruction: values.instruction
        })
        .then(
          (result: any) => {
            resolve()
          },
          (err: any) => {
            reject(err)
          }
        )
    })
  }

  private onSuccess = () => {
    setTimeout(() => {
      this.onCancel()
    }, 1000)
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/assistance')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AddAssistanceModal.tsx